import { showCreateSiteModal } from '../../Manage/actions'
import { ACTION_UPDATE } from 'components/UpdateSiteModal/constants'
import { hasFeature } from '../../utils/general'
import { F_EDIT_MODE } from 'constants/plans/constants'
import { getDirectFileLinkForSite, isDevSite, isEligibleForAIEdit, openAIEditor } from '../../utils/general'
import OptionsModalOption from './components/OptionsModalOption'
import { API_ROOT } from '../../constants'

const getUpdateOptions = ({
  isPDF,
  isPHP,
  isHTML,
  isCollection,
  isPasswordProtected,
  isEmailCaptureEnabled,
  isEmailWhitelistEnabled,
  dispatch,
  history,
  onClose,
  site,
  userProfile,
  onEditPDF
}) => {
  const isAIEligible = isEligibleForAIEdit(userProfile, site)

  const onCustomisePasswordPage = (subdomain) => {
    if (isDevSite()) {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    } else {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    }
  }

  const onCustomiseEmailCapturePage = (subdomain) => {
    if (isDevSite()) {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    } else {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    }
  }

  const onCustomiseEmailWhitelistPage = (subdomain) => {
    if (isDevSite()) {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    } else {
      window.open(`/editor/?domain=${subdomain}&file=/_auth/index.html&customize-auth=true`, '_blank')
    }
  }

  const handleEditPdfWithPSWD = (password, fileLink) => {
    if (password) {
      const token = btoa(password)
      const proxyUrl = `${API_ROOT}/v3/editor/set-cookie-and-proxy?url=${encodeURIComponent(fileLink)}&token=${encodeURIComponent(token)}`
      onEditPDF(proxyUrl)
    } else {
      onEditPDF(fileLink)
    }
  }

  const handleEditPDF = (site) => {
    const fileLink = getDirectFileLinkForSite(site)
    handleEditPdfWithPSWD(site?.password, fileLink)
  }

  const onEditHTML = (subdomain, isTrial) => {
    openAIEditor(subdomain, isTrial)
  }

  return [
    {
      isVisible: true,
      component: (
        <OptionsModalOption
          icon="/assets/icons/replace.svg"
          title="Update files"
          description="Replace or update the files for this project"
          onClick={() => {
            dispatch(showCreateSiteModal(true, { ...site, domain: site.subdomain }, ACTION_UPDATE))
            onClose()
          }}
          dataTestId="UpdateOption-button-update-files"
        />
      )
    },
    {
      isVisible: true,
      component: (
        <OptionsModalOption
          icon="/assets/icons/edit.svg"
          title="Customize project"
          description="Modify project settings and details"
          onClick={() => {
            history.push(`/manage/update?site=${encodeURIComponent(site.subdomain)}&tab=access_settings`)
            dispatch(showCreateSiteModal(true, { ...site, domain: site.subdomain }, ACTION_UPDATE))
            onClose()
          }}
        />
      )
    },
    {
      isVisible: isPDF,
      component: (
        <OptionsModalOption
          icon="/assets/icons/edit.svg"
          title="Edit PDF text"
          description="Edit the text content of your PDF file"
          onClick={() => {
            handleEditPDF(site)
            onClose()
          }}
          dataTestId="UpdateOption-button-edit-pdf-file"
        />
      )
    },
    {
      isVisible: !isPHP && isHTML && !isCollection,
      component: (
        <OptionsModalOption
          icon="/assets/icons/edit.svg"
          title={isAIEligible ? 'Edit with AI' : 'Edit HTML'}
          description="Modify the HTML, CSS, or JS of your website"
          onClick={() => {
            onEditHTML(site.subdomain, !hasFeature(userProfile.productId, F_EDIT_MODE))
            onClose()
          }}
        />
      )
    },
    {
      isVisible: isPasswordProtected,
      component: (
        <OptionsModalOption
          icon="/assets/icons/lock-black.svg"
          title="Customize password protection"
          description="Update the password settings for this project"
          onClick={() => {
            onCustomisePasswordPage(site.subdomain)
          }}
        />
      )
    },
    {
      isVisible: isEmailCaptureEnabled,
      component: (
        <OptionsModalOption
          icon="/assets/icons/edit.svg"
          title="Customize email capture page"
          description="Update the email capture settings for this project"
          onClick={() => {
            onCustomiseEmailCapturePage(site.subdomain)
          }}
        />
      )
    },
    {
      isVisible: isEmailWhitelistEnabled,
      component: (
        <OptionsModalOption
          icon="/assets/icons/edit.svg"
          title="Customize email whitelist page"
          description="Update the email whitelist settings for this project"
          onClick={() => {
            onCustomiseEmailWhitelistPage(site.subdomain)
          }}
        />
      )
    }
  ]
}

export default getUpdateOptions
